import { Model } from '@/services/api/lib'

class Campaign extends Model {
  resource () {
    return 'promotions/v1/promotions'
  }

  defaults () {
    return {
      active: false,
      code: '',
      condition: {
        children: [],
        logicalOperator: 'All',
        subsets: []
      },
      customer_group: [],
      description: '',
      end_date: null,
      exclusive: false,
      max_customer_uses: null,
      max_total_uses: null,
      name: '',
      priority: 1,
      rate_type: 'percentage',
      start_date: null,
      target: 'items',
      target_condition: null,
      tenancy: 1,
      total_times_used: 0,
      type: 'catalog',
      value: 0
    }
  }

  validations () {
    return {
      'name': 'required|string',
      'description': 'required|string',
      'type': 'required|string',
      'start_date': 'string',
      'end_date': 'string',
      'rate_type': 'required|string',
      'value': 'required|number|min:0',
      'priority': 'required|number|min:0',
      'exclusive': 'required|boolean',
      'customer_group': 'array',
      'target': 'required|string',
      'code': 'string|required_when:type,coupon',
      'max_total_uses': 'number|min:0',
      'max_customer_uses': 'number|min:0',
      'condition': 'object'
    }
  }
}

export default {
  Campaign
}
